module.exports = __webpack_public_path__ + "img/logo-mobile.19699b96.svg";